<template>
  <div>
    <div class="mt-5">
      <form-wizard
        error-color="rgb(242, 19, 93)"
        color="rgba(var(--vs-primary), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Submit"
        @on-complete="submitDetails"
        @on-error="handleErrorMessage"
      >


        <!-- tab 2 content -->
        <tab-content title="Step 1" class="mb-5" icon="feather icon-info"  :before-change="validOne">
          <p>Key In <b>Transporter Information</b> and Proceed.</p>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input
                label="Name"
                v-model="tpInfo.name"
                class="w-full mt-4"
              />
              <vs-input
                label="Code"
                v-model="tpInfo.code"
                class="w-full mt-4"
              />
                <vs-input
                label="Person In Charge Name"
                v-model="tpInfo.picName"
                class="w-full mt-4"
              />
                <vs-input
                label="Person In Charge Number"
                v-model="tpInfo.picNumber"
                class="w-full mt-4"
              />
                   <label class="vs-input--label">Cargo/Tonnage Options</label>
               <v-select :options="industries2" v-model="tpInfo.cargo" taggable multiple placeholder="Select"  />

               <label class="vs-input--label">Industry/Type</label>
               <v-select :options="industries" v-model="tpInfo.industry" taggable multiple  placeholder="Select"  />

               <vs-textarea
                v-model="tpInfo.address"
                label="Address"
                class="mb-0 md:mt-10 mt-6"
                rows="3"
              />


             </div>

            <div class="vx-col md:w-1/2 w-full">
                  <vs-input
                 type="text"
                label="Portal Username"
                v-model="tpInfo.tsUsername"
                class="w-full mt-4"
              />
                <vs-input
                 type="text"
                label="Portal Password."
                v-model="tpInfo.tsPassword"
                class="w-full mt-4"
              />
              <vs-textarea
                v-model="tpInfo.remarks"
                label="Remarks"
                class="mb-0 md:mt-10 mt-6"
                rows="3"
              />
               <br>
           <label for="myvueDropZone">Upload Docs</label>


              <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="vehicleImagesUpload"  v-on:vdropzone-removed-file="vehicleImagesRemove"></vue-dropzone>

            </div>
          </div>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content title="Step 2" class="mb-5" icon="feather icon-paperclip" :before-change="validTwo">
          <p>
            Take a moment to <b>Add Transporter Assets</b> for easier Trip Management later.   <br><vs-button color="primary" type="border" icon-pack="feather" icon="icon-layout" @click="addAlarm">Add Asset</vs-button>
          </p>

          <table class="responsive">
            <tr>
                <th>No.</th>
            <th>Plate No.</th>
            <th>GPS Unit Id (*)</th>
            <th>Type</th>
            <th>Remarks</th>
            <th>Actions</th>
            </tr>

              <tr :key="indextr" v-for="(tr, indextr) in tpAssets">
                    <td>
                        <span> <b>{{indextr+1}}.</b></span>
                    </td>
                     <td>
                      <input
                type="text"
                v-model="tpAssets[indextr].plateNo"
                class="w-full mt-5"
              />
                    </td>
                    <td>
                      <input
                type="text"
                v-model="tpAssets[indextr].unitId"
                class="w-full mt-5"
              />
                    </td>
                    <td>
                  <v-select placeholder="Type" clearable="false" taggable :options="industries2"  v-model="tpAssets[indextr].type" />
                    </td>

                      <td>
                          <vs-textarea
                v-model="tpAssets[indextr].remark"
                  class="w-full mt-5"
                rows="4"
              />
                    </td>
                    <td>
                      <vs-button color="danger" @click="removeAlarm(indextr)">Remove</vs-button> &nbsp;
                    </td>
                </tr>
          </table>
        </tab-content>

   <!-- tab 2 content -->
       <tab-content title="Step 3" class="mb-5" icon="feather icon-aperture" >
          <p>
            Setup <b>Notification Channels</b> to receive reminders in your
            preffered apps.  Push Notifications are turned ON by DEFAULT.
          </p>
           <h5>How to Receive Telegram Notifications</h5>
  <ul>
    <li>1. Click to Send message to our <a href="https://t.me/Igeotechgps_bot" target="_blank">Igeotechgps Telegram account</a> </li>
    <li>2. COPY & PASTE the Chat ID received in the details section. </li>
    <li>3. If need assistance text us as <a :href="'https://api.whatsapp.com/send?phone='+userInfo.help_whatsapp+'&text=Hi%20Igeotechgps%20Support!'" target="_blank">Igeotechgps Support</a>   </li>
  </ul>

  <br>
            <vs-button color="primary" type="border" icon-pack="feather" icon="icon-phone" @click="addNotification">Add New Channel</vs-button>
                         <table class="responsive">
            <tr>
                <th>No.</th>
            <th>Type</th>
            <th>Detail</th>
            <th>Remarks</th>
            <th>Actions</th>
            </tr>
            <tr>
 <tr :key="indextr" v-for="(tr, indextr) in tpNotifications">
                    <td>
                        <span> <b>{{indextr+1}}.</b></span>
                    </td>
                    <td>
                  <v-select placeholder="Type" clearable="false" :options="['Telegram','Email']"  v-model="tpNotifications[indextr].type" />
                    </td>
                    <td>
                    <vs-input
        v-validate="'required'"
        data-vv-validate-on="blur"
        v-model="tpNotifications[indextr].detail"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Details"

        class="w-full"/>
                    </td>
                      <td>
                    <vs-input
        v-validate="'required'"
        data-vv-validate-on="blur"
        v-model="tpNotifications[indextr].remark"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Remarks"

        class="w-full"/>
                    </td>
                    <td>
                      <vs-button color="danger" @click="removeNotification(indextr)">Remove</vs-button> &nbsp;
                    </td>
                </tr>


            </table>

        </tab-content>
        <tab-content title="Step 4" class="mb-5" icon="feather icon-paperclip">
          <p>
            Take a moment to <b>Add API Integration Endpoints</b> for easier Trip Management later.   <br><vs-button color="primary" type="border" icon-pack="feather" icon="icon-layout" @click="addAlarm2">Add API Endpoints</vs-button>
          </p>

          <table class="responsive">
            <tr>
                <th>No.</th>
            <th>Type</th>
            <th>Source IP</th>
            <th>Endpoint</th>
            <th>Parameters</th>
            <th>Remarks</th>
            <th>Actions</th>
            </tr>

              <tr :key="indextr" v-for="(tr, indextr) in tpEndpoints">
                    <td>
                        <span> <b>{{indextr+1}}.</b></span>
                    </td>
                     <td>
                      <v-select placeholder="Type" clearable="false" :options="['New Order','Order Acceptance','Order Cancellation','Order Modification','Trip Delay','Trip Deviation','Trip Completion','Trip Details']"  v-model="tpEndpoints[indextr].type" />
                    </td>
                    <td>
                      <input
                type="text"
                v-model="tpEndpoints[indextr].source"
                class="w-full mt-5"
              />
                    </td>
                    <td>
        <input
                type="text"
                v-model="tpEndpoints[indextr].endpoint"
                class="w-full mt-5"
              />
                    </td>
              <td>
                          <vs-textarea
                v-model="tpEndpoints[indextr].params"
                  class="w-full mt-5"
                rows="4"
              />
                    </td>
                      <td>
                          <vs-textarea
                v-model="tpEndpoints[indextr].remark"
                  class="w-full mt-5"
                rows="4"
              />
                    </td>
                    <td>
                      <vs-button color="danger" @click="removeAlarm2(indextr)">Remove</vs-button> &nbsp;
                    </td>
                </tr>
          </table>
        </tab-content>


        <!-- tab 4 content -->


        <div class="loader" v-if="loadingWizard"></div>
        <div v-if="errorMsg!=''">
          <span class="error">{{errorMsg}}</span>
        </div>
      </form-wizard>
    </div>
  </div>
</template>

<script>

import {FormWizard, TabContent} from 'vue-form-wizard'
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns'
import { Query, Predicate } from '@syncfusion/ej2-data'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vSelect from 'vue-select'
import { getBaseURL } from '@/config.js'


export default {
  data () {
    return {
      quickSelect:null,
      userInfo:JSON.parse(localStorage.getItem('userInfo')),
      allowCustomValue:true,
      loadingWizard: false,
      errorMsg: null,
      tpAssets:[],
      refresh:0,
      industries2:[
        '1 Tonne',
        '2 Tonnes',
        '3 Tonnes',
        '5 Tonnes',
        '5 Tonnes (Box lorry)',
        '10 Tonnes (Loading Capability Of 8 Tonnes)',
        '15 Tonnes (Loading Capability Of 14 Tonnes)',
        '1 tonne', '3 / 5 tonne', '10 Tonne (Cargo Truck)', '10 Tonne Tipper / Crane - 1', '20 Tonne Tipper / Crane - 1', 'Ready Mix', 'Prime Movers - 1', 'Prime Movers - 2'
      ],
      industries:[
        'Personal Usage',
        'Agriculture & Farm Product',
        'Construction',
        'Container Handling',
        'Container Haulage',
        'Courier',
        'Drilling Rig Machine',
        'Food Distribution',
        'General Cargo',
        'Manufacturing Raw Materials',
        'Milling Machine',
        'Palm Oil',
        'Pavers',
        'Petro Chemical Tankers',
        'Road Roller',
        'Skid Steer Roller',
        'Stacker',
        'Transport',
        'Tractor',
        'Tractor Back Pusher',
        'Utility & Public Services'
      ],
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      tpInfo:{
        assetId:-1,
        plate:null,
        type:'',
        subType:'',
        brand:'',
        model:'',
        industry:null,
        class:null,
        vehicleImages:[]
      },
      tpEndpoints:[],
      tpNotifications:[],
      dropzoneOptions: {
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 15,
        addRemoveLinks: true
        //autoProcessQueue: false
      }
    }
  },
  watch: {

  },
  methods: {
    contactSupport () {
      window.open(`https://api.whatsapp.com/send?phone=${this.userInfo.help_whatsapp}&text=Hi%20Igeotechgps%20Support!`)
    },
    driverDocumentsUpload (event, index) {
      this.tpAssets[index].documents.push(JSON.parse(event.xhr.response).path)
      //   console.log(this.tpAssets);
    },
    removeAlarm (index) {
      this.tpAssets.splice(index, 1)
    },
    addAlarm () {

      this.tpAssets.push({ plateNo:'', unitId:'', type:'', date:'', mileage:'', documents:[], remark:'Others:-'})
    },
    removeAlarm2 (index) {
      this.tpEndpoints.splice(index, 1)
    },
    removeNotification (index) {
      this.tpNotifications.splice(index, 1)
    },
    addNotification () {
      this.tpNotifications.push({type:'', detail:'', remark:''})
    },
    addAlarm2 () {

      this.tpEndpoints.push({ params:'', source:'', endpoints:'', type:'', remark:'Others:-'})
    },
    handleErrorMessage (errorMsg) {
      this.errorMsg = errorMsg
    },
    vehicleImagesUpload (files, response) {
      this.tpInfo.vehicleImages.push(response.path)
    },

    validOne () {

      return new Promise((resolve, reject) => {

        if (this.tpInfo.name == null || this.tpInfo.name == '') {

         	reject('Key in Name. to continue..')
        }
        if (this.tpInfo.code == null || this.tpInfo.code == '') {

         	reject('Key in TS Code to continue..')
        } else {
          resolve(true)
        }

      })
    },
    validTwo () {

      return new Promise((resolve, reject) => {


        if (this.tpInfo.name == null || this.tpInfo.name == '') {

         	reject('Key in Name. to continue..')
        }
        if (this.tpInfo.code == null || this.tpInfo.code == '') {

         	reject('Key in TS Code to continue..')
        }


        if (this.tpAssets.length == 0) {

         	reject('Add at least 1 asset to continue..')
        } else {
          resolve(true)
        }

      })
    },

    formSubmitted () {
      alert('Form submitted!')
    },
    submitDetails () {
      const self = this

      self.$http.post('transporters/submit', {
        userInfo:self.userInfo,
        tpInfo:self.tpInfo,
        tpAssets:self.tpAssets,
        tpEndpoints:self.tpEndpoints,
        tpNotifications:self.tpNotifications
      })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.$emit('exit', true)
            return  self.$vs.notify({
              title: 'New record added',
              text: 'Transporter info added!',
              iconPack: 'feather',
              icon: 'icon-refresh-cw',
              color: 'success'
            })

          } else {
            self.$emit('exit', true)
            if (response.data.error) {

              return  self.$vs.notify({
                title: 'Error',
                text: response.data.error,
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning'
              })
            } else {

              return  self.$vs.notify({
                title: 'Error',
                text: 'Could not created FMS Transporter record at this time.Try again later.',
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning'
              })
            }
          }
        })
        .catch(function (error) {
          self.$emit('exit', true)
        })
    }
  },
  mounted () {

  },
  components: {
    FormWizard,
    TabContent,
    MultiSelectPlugin,
    Query,
    Predicate,
    vueDropzone: vue2Dropzone,
    vSelect
  }
}
</script>

<style scoped>
@import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";

.e-multiselect {
  border-bottom: 1px solid #ffffff;
  font-family: "Montserrat";
}
.e-multi-select-wrapper {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  font-family: "Montserrat";
  height: 40px;
}

.e-multi-select-wrapper-e-delimiter {
  font-family: "Montserrat";
}
.error {
  color:'red';
  font-weight:'bold';
  font-size:'20px'

}
.vs-table {
overflow-y: visible !important;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}


</style>
